import Axios from 'axios'
import {APIBase, StaticApiBase} from "./urlService";

function getAxios(isStatic) {
  let baseUrl = isStatic ? StaticApiBase : APIBase;
  let userInfo = window.localStorage.getItem('kkComicUserInfo');
  if (userInfo == "undefined"){
    userInfo = null;
    window.localStorage.removeItem("kkComicUserInfo");
  }else{
    userInfo = JSON.parse(userInfo);
  }
  let traceId = window.localStorage.getItem('kkComicTraceId');
  let branchId = window.localStorage.getItem('kkComicBranchId');
  if (!branchId) {
    if (userInfo) {
      branchId = userInfo.branchId;
    }else {
      branchId = -2;
    }
  }
  let headers = {
    'User-Trace-Id': traceId ? traceId : '',
    'User-Id': userInfo ? userInfo.userId : '',
    'User-Account': userInfo ? userInfo.account : '',
    'Current-Branch-Id': branchId ? branchId : '',
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  return Axios.create({
    // baseURL: baseUrl,
    timeout: 30000,
    headers: headers
  })
}

export default getAxios;

export {getAxios};



// WEBPACK FOOTER //
// ./src/services/axiosService.js